import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Subheader from 'material-ui/Subheader';

import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';

import { Card, CardHeader, CardText } from 'material-ui/Card';

import {
  MdInfoOutline as InfoIcon,
  MdInsertPhoto as PhotoIcon,
  MdDescription as DetailsIcon,
} from 'react-icons/md';

import StopWatch from './StopWatch';

import { CSSTransitionGroup } from 'react-transition-group';

import { featureEnabled } from 'helpers/ToggleBot';
import { formatBoolean, toFriendlyDateString } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

export default connect((store) => ({
  ticketDetails: store.maintenanceTicket.ticketDetails,
  time: store.timer.time,
  isOn: store.timer.isOn,
  showSaveJob: store.timer.showSaveJob,
}))(
  class TicketInformation extends Component {
    render() {
      const { ticketInformation, jobStarted } = this.props;

      const style = {
        card_header: {
          backgroundColor: '#fff',
          borderBottom: '1px solid #e0e0e0',
          padding: '11px 16px',
          fontFamily: 'Circular-Bold',
          backgroundImage: `-webkit-linear-gradient(left, ${AccentColor()}d6, ${AccentColor()}d6 49px, transparent 49px, transparent 100%)`,
          width: '100%',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
        },
        card_text: {
          padding: '8px 4px',
          fontFamily: '"Circular", sans-serif !important',
        },
        card_text_min_height: {
          padding: '8px 4px',
          fontFamily: '"Circular", sans-serif !important',
          minHeight: '148px',
        },
        no_padding: {
          padding: 0,
        },
        subheader: {
          lineHeight: 0,
          padding: '20px 16px 10px 16px',
        },
        lease_term: {
          margin: 0,
          fontSize: '15px',
        },
        internal_note: {
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
          margin: 0,
          fontSize: '15px',
        },
        subheader_side_padding: {
          padding: '0 16px',
        },
      };

      return (
        <Fragment>
          <CSSTransitionGroup
            transitionName="start_job"
            style={{ width: '100%' }}
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {jobStarted && (
              <div className="row" style={{ marginBottom: '10px' }}>
                <Card className="card">
                  <CardText>
                    <StopWatch
                      isOn={this.props.isOn}
                      showSaveJob={this.props.showSaveJob}
                      toggleContractorDialog={this.props.toggleContractorDialog}
                      endPauseJob={this.props.endPauseJob}
                    />
                  </CardText>
                </Card>
              </div>
            )}
          </CSSTransitionGroup>

          <div className="row">
            <Card className="card">
              <CardHeader
                style={style.card_header}
                title={
                  <span style={{ width: '200px', display: 'block' }}>
                    <InfoIcon
                      size={18}
                      style={{
                        verticalAlign: 'middle',
                        marginRight: '26px',
                        color: 'white',
                      }}
                    />
                    &nbsp;Ticket Info{' '}
                  </span>
                }
              />
              <CardText style={style.card_text}>
                <div className="row">
                  <div className="col-sm-6" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Property
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.property_name}</p>
                    </div>
                  </div>
                  {ticketInformation.unit_number && (
                    <div className="col-sm-6" style={style.no_padding}>
                      <Subheader inset={false} style={style.subheader}>
                        Unit
                      </Subheader>
                      <div style={style.subheader_side_padding}>
                        <p style={style.lease_term}>{ticketInformation.unit_number}</p>
                      </div>
                    </div>
                  )}
                  {ticketInformation.assign && (
                    <div className="col-sm-12" style={style.no_padding}>
                      <Subheader inset={false} style={style.subheader}>
                        Assigned To
                      </Subheader>
                      <div style={style.subheader_side_padding}>
                        <p style={style.lease_term}>{ticketInformation.assign.label}</p>
                      </div>
                    </div>
                  )}
                  <div className="col-sm-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Priority
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.priority}</p>
                    </div>
                  </div>
                  <div className="col-sm-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Request Type
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.request_type}</p>
                    </div>
                  </div>
                  <div className="col-sm-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Status
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.status}</p>
                    </div>
                  </div>
                  <RenderIfToggleOn toggle="maintenance.scheduling">
                    <div className="col-sm-12" style={style.no_padding}>
                      <Subheader inset={false} style={style.subheader}>
                        Scheduled Repair Date
                      </Subheader>
                      <div style={style.subheader_side_padding}>
                        {ticketInformation.scheduled_at && (
                          <p style={style.lease_term}>
                            {toFriendlyDateString(ticketInformation.scheduled_at)}
                          </p>
                        )}
                        {!ticketInformation.scheduled_at && (
                          <p style={style.lease_term}>Pending Scheduling</p>
                        )}
                      </div>
                    </div>
                  </RenderIfToggleOn>
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Permission to Enter
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>
                        {formatBoolean(ticketInformation.permission_to_enter)}
                      </p>
                    </div>
                  </div>
                  {featureEnabled('ui.create_service_request.consent_to_entry_while_away') && (
                    <div className="col-xs-12" style={style.no_padding}>
                      <Subheader inset={false} style={style.subheader}>
                        {getTranslatedString(
                          'landlordPortal.serviceRequest.consentToEntryWhileAway'
                        )}
                      </Subheader>
                      <div style={style.subheader_side_padding}>
                        <p style={style.lease_term}>
                          {formatBoolean(ticketInformation.consent_to_entry_while_away)}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Has Pet
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{formatBoolean(ticketInformation.has_pets)}</p>
                    </div>
                  </div>
                </div>
              </CardText>
            </Card>
          </div>

          <div className="row" style={{ marginTop: '10px' }}>
            <Card className="card">
              <CardHeader
                style={style.card_header}
                title={
                  <span style={{ width: '200px', display: 'block' }}>
                    <DetailsIcon
                      size={18}
                      style={{
                        verticalAlign: 'middle',
                        marginRight: '26px',
                        color: 'white',
                      }}
                    />
                    &nbsp;Details{' '}
                  </span>
                }
              />
              <CardText style={style.card_text}>
                <div className="row">
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Subject
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.subject}</p>
                    </div>
                  </div>
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Description
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.lease_term}>{ticketInformation.ticket_description}</p>
                    </div>
                  </div>
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Location
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.internal_note}>{ticketInformation.suite_location}</p>
                    </div>
                  </div>
                  <RenderIfToggleOn toggle="ui.maintenance.show_external_po_number_field">
                    <div className="col-xs-12" style={style.no_padding}>
                      <Subheader inset={false} style={style.subheader}>
                        {getTranslatedString(
                          'landlordPortal.editMaintenanceTicketForm.externalPoNumber'
                        )}
                      </Subheader>
                      <div style={style.subheader_side_padding}>
                        <p style={style.internal_note}>{ticketInformation.external_po_number}</p>
                      </div>
                    </div>
                  </RenderIfToggleOn>
                  <div className="col-xs-12" style={style.no_padding}>
                    <Subheader inset={false} style={style.subheader}>
                      Internal Notes
                    </Subheader>
                    <div style={style.subheader_side_padding}>
                      <p style={style.internal_note}>{ticketInformation.internal_notes}</p>
                    </div>
                  </div>
                </div>
              </CardText>
            </Card>
          </div>
          {this.props.ticketDetails.photos.length > 0 && (
            <div className="row" style={{ marginTop: '10px' }}>
              <Card className="card">
                <CardHeader
                  style={style.card_header}
                  title={
                    <span style={{ display: 'block' }}>
                      <PhotoIcon
                        size={18}
                        style={{
                          verticalAlign: 'middle',
                          marginRight: '26px',
                          color: 'white',
                        }}
                      />
                      &nbsp;Images{' '}
                    </span>
                  }
                />
                <CardText>
                  <div className="row">
                    <RenderDropzoneMultiFileInput
                      hideDropzone
                      uploadedFiles={this.props.ticketDetails.photos}
                      useLightbox
                    />
                  </div>
                </CardText>
              </Card>
            </div>
          )}
        </Fragment>
      );
    }
  }
);
